import _classCallCheck from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/* Autogenerated file. Do not edit manually. */

/* tslint:disable */

/* eslint-disable */
import { Contract, utils } from "ethers";
var _abi = [{
  inputs: [{
    internalType: "address[]",
    name: "tokens",
    type: "address[]"
  }, {
    internalType: "address[]",
    name: "baseTokens",
    type: "address[]"
  }, {
    internalType: "uint256",
    name: "amountToBorrow",
    type: "uint256"
  }],
  name: "batchValidate",
  outputs: [{
    internalType: "enum ITokenValidator.Status[]",
    name: "",
    type: "uint8[]"
  }],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "token",
    type: "address"
  }, {
    internalType: "address[]",
    name: "baseTokens",
    type: "address[]"
  }, {
    internalType: "uint256",
    name: "amountToBorrow",
    type: "uint256"
  }],
  name: "validate",
  outputs: [{
    internalType: "enum ITokenValidator.Status",
    name: "",
    type: "uint8"
  }],
  stateMutability: "nonpayable",
  type: "function"
}];
export var ITokenValidator__factory = /*#__PURE__*/function () {
  function ITokenValidator__factory() {
    _classCallCheck(this, ITokenValidator__factory);
  }

  _createClass(ITokenValidator__factory, null, [{
    key: "createInterface",
    value: function createInterface() {
      return new utils.Interface(_abi);
    }
  }, {
    key: "connect",
    value: function connect(address, signerOrProvider) {
      return new Contract(address, _abi, signerOrProvider);
    }
  }]);

  return ITokenValidator__factory;
}();
ITokenValidator__factory.abi = _abi;